import React, {ReactElement} from 'react'
import {Accordion, AccordionDetails, AccordionSummary} from '@mui/material'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import styled from 'styled-components'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

const AccordionContainer = styled.div`
    padding-top: 2em;
`

const StyledAccordionSummary = styled(AccordionSummary)`
    background-color: ${ThemeColorsHospitalic.PRIMARY_LIGHT};
`

const StyledAccordion = styled(Accordion)`
    background-color: transparent;
    box-shadow: none !important;
`

const StyledAccordionDetails = styled(AccordionDetails)`
    padding-right: 0;
    padding-left: 0;
`

type CollapsibleSectionProps = {
    defaultExpanded?: boolean
    header: string;
    children: ReactElement
}

const CollapsibleSection = ({header, children, defaultExpanded = false}: CollapsibleSectionProps) => {
    return (
        <AccordionContainer>
            <StyledAccordion defaultExpanded={defaultExpanded}>
                <StyledAccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography variant='h5'>{header}</Typography>
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                    {children}
                </StyledAccordionDetails>
            </StyledAccordion>
        </AccordionContainer>
    )
}

export default CollapsibleSection